import { render, staticRenderFns } from "./AnchoredHeading.vue?vue&type=template&id=6e1b3842&scoped=true&"
import script from "./AnchoredHeading.vue?vue&type=script&lang=ts&"
export * from "./AnchoredHeading.vue?vue&type=script&lang=ts&"
import style0 from "./AnchoredHeading.vue?vue&type=style&index=0&id=6e1b3842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1b3842",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
